// extracted by mini-css-extract-plugin
export default {"container":"bPYPKBclKHRislHL19JK","title":"PhqGYr3PlU50NSZ2_Qca","subtitle":"OotxV0zFvhuassSakaoF"};